import "@fontsource/inter";
import "@fontsource/inter/700.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/400.css";
import styled from "styled-components";
import { theme } from "../../../theme";

const Small = styled.div<{
  textalign?: string;
  color?: string;
  fontweight?: string | number;
}>`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  line-height: 18px;
  font-weight: ${(props) => props.fontweight ?? "500"};
`;

export default Small;
